import { RowIds } from "./utils/consts";
import type { RowId } from "./utils/types";

/**
 * Stable testIDs for price-summary rows → DS PriceLineItem.
 *
 * These mirror the legacy `*-line-item` ids that the TAF suite selects on, so
 * mutually exclusive rows (DIY vs FSV space rental, day-rate discount vs its
 * dateless readout) intentionally share an id. Rows still marked
 * `price-summary-*` have no legacy counterpart to match.
 */
export const rowTestIds = {
  [RowIds.SpaceRentalReadout]: "hourly-rate-line-item",
  [RowIds.DiySpaceRental]: "space-rental-line-item",
  [RowIds.DiySpaceRentalRate]: "space-rental-line-item",
  [RowIds.FsvSpaceRental]: "space-rental-line-item",
  [RowIds.DayRateDiscountReadout]: "discount-line-item",
  [RowIds.DayRateDiscount]: "discount-line-item",
  [RowIds.Entitlement]: "discount-line-item",
  [RowIds.FoodDrinkMinimum]: "prepaid-menu-line-item",
  [RowIds.AddOnsTotal]: "add-ons-line-item",
  [RowIds.AdditionalPaymentsTotal]: "price-summary-additional-payments-total",
  [RowIds.CleaningFee]: "cleaning-fee-line-item",
  [RowIds.SplitPaymentFee]: "split-payment-fee-line-item",
  [RowIds.ProcessingFee]: "processing-line-item",
  [RowIds.Taxes]: "taxes-line-item",
  [RowIds.Credits]: "applied-credits-line-item",
  [RowIds.TerminalBookingOffset]: "price-summary-terminal-booking-offset",
  [RowIds.BookingTotal]: "total-line-item",
  [RowIds.StaffGratuity]: "gratuity-line-item",
  [RowIds.HostInlineServiceFee]: "price-summary-host-inline-service-fee",
  [RowIds.VatTaxes]: "price-summary-vat-taxes",
  [RowIds.PaymentAmount]: "price-summary-payment-amount",
  [RowIds.DueAtVenueInline]: "price-summary-due-at-venue-inline",
  [RowIds.EarningsSubtotal]: "subtotal-line-item",
  [RowIds.HostFee]: "service-fee-line-item",
  [RowIds.EstimatedEarnings]: "price-summary-estimated-earnings",
  [RowIds.PayoutFromPeerspace]: "price-summary-payout-from-peerspace",
  [RowIds.GuestSpendAtVenue]: "price-summary-guest-spend-at-venue",
  [RowIds.DueToday]: "due-now-line-item",
  [RowIds.PaidToDate]: "previous-payment-line-item",
  [RowIds.DifferenceDueToday]: "price-difference-line-item",
  [RowIds.Refund]: "refund-line-item",
  [RowIds.UpcomingCharge]: "scheduled-payment-line-item",
  [RowIds.DueAtVenue]: "price-summary-due-at-venue",
  [RowIds.CollectedFoodDrinkMinimum]:
    "price-summary-collected-food-drink-minimum",
  [RowIds.CollectedAddOnsTotal]: "price-summary-collected-add-ons-total",
  [RowIds.CollectedGuestSpendAtVenue]:
    "price-summary-collected-guest-spend-at-venue",
} as const satisfies Record<RowId, string>;
